import React from 'react';
import {Link } from "react-router-dom";
import { ROUTES } from '../../routes';
import useCustomTranslation from '../../hooks/useCustomTranslation';

const Navigation = (props) => {

  const ct = useCustomTranslation();
  const navElements = [
    { title: ct('account.navigation.to_account'), linkTo: ROUTES.TO_ACCOUNT, key: "profile"},
    { title: ct('account.navigation.to_change_password'), linkTo: ROUTES.TO_CHANGE_PASSWORD, key: "change_password" },
    //{ title: ct('account.navigation.to_settings'), linkTo: ROUTES.TO_SETTINGS, key: "settings"},
    { title: ct('account.navigation.to_manage_access_token'), linkTo: ROUTES.TO_MANAGE_ACCESS_TOKEN, key: "manage_access_token" },
    { title: ct('account.navigation.to_delete_account'), linkTo: ROUTES.TO_ELIMINATE_ACCOUNT, key: "eliminate_account" },
  ]

  const linkClass = (key) => {
    return (key === props.activeItem)? "nav-link active" : "nav-link"
  }

  return (
    <ul className="nav nav-tabs flex-lg-column" role="tablist">
      {
        navElements.map( (e, i) => <li key={e.key} className="nav-item"><Link className={linkClass(e.key)} to={e.linkTo}>{e.title}</Link></li> )
      }
    </ul>
  )
}

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/User/Navigation.js